module.exports = __webpack_public_path__ + "img/partner26.499c2c00.png";